import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPorjectInputModel } from 'src/app/ViewModel/ScheduleDefinitionModel';
import { RestApiService } from '../rest-api.service';

@Injectable({ providedIn: "root" })
export class DocumentViewerService {
    private endPoints = {
        "createTranslateJob": "Viewer/CreateTranslateJob",
        "getCompareDocuments":"Viewer/GetCompareDocuments",
    }
    constructor(private restAPIService: RestApiService) { }


    /**
     * Insert CreateTranmittal pending job
     * @param organization 
     */
    public CreateTranslateJob(fileModel: any): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.createTranslateJob, fileModel);
    }

    public GetCompareDocuments(projectModel:IPorjectInputModel):Observable<any>{
        return this.restAPIService.new_POST(this.endPoints.getCompareDocuments,projectModel)
    }
}
